(function() {
  var WEBHOOK_URL = 'https://thehealthhub-n8n.ygtaig.easypanel.host/webhook/healthhub-bot';
  var CLICK_WEBHOOK_URL = 'https://thehealthhub-n8n.ygtaig.easypanel.host/webhook/healthhub-click';
  var TIMEOUT_MS = 120000;
  var HANDSHAKE_TIMEOUT_MS = 250;
  var CHANNEL_NAME = 'hh_session_sync';

  // ---------- State (in-memory only, never persisted to disk) ----------
  var sessionId = null;
  var history = [];
  var hasOpened = false;
  var isReady = false;

  var widget, toggle, closeBtn, messages, input, sendBtn, dot, bubbleEl;
  var isOpen = false, isLoading = false;
  var elapsedSeconds = 0, elapsedInterval = null;

  // ---------- Cross-tab sync ----------
  var channel = null;

  function isReload() {
    try {
      var entries = performance.getEntriesByType('navigation');
      if (entries && entries[0]) return entries[0].type === 'reload';
    } catch(e) {}
    try {
      if (performance.navigation) return performance.navigation.type === 1;
    } catch(e) {}
    return false;
  }

  function generateSessionId() {
    return 'HH-' + Math.random().toString(36).substr(2, 6).toUpperCase();
  }

  function initFresh() {
    sessionId = generateSessionId();
    history = [];
    hasOpened = false;
  }

  function setupChannel() {
    if (typeof BroadcastChannel === 'undefined') return;
    try {
      channel = new BroadcastChannel(CHANNEL_NAME);
      channel.addEventListener('message', onChannelMessage);
    } catch(e) {
      channel = null;
    }
  }

  function onChannelMessage(e) {
    var data = e.data || {};

    // Another tab wants to know if anyone has an active session
    if (data.type === 'WHO_HAS_SESSION' && sessionId && isReady) {
      try {
        channel.postMessage({
          type: 'SESSION_RESPONSE',
          sessionId: sessionId,
          history: history,
          hasOpened: hasOpened
        });
      } catch(e) {}
      return;
    }

    // Live sync: another tab updated state for our session
    if (data.type === 'SESSION_UPDATE' && data.sessionId === sessionId) {
      history = data.history || history;
      hasOpened = data.hasOpened !== undefined ? data.hasOpened : hasOpened;
      if (isOpen && messages) {
        rerenderMessages();
      }
    }
  }

  function broadcastUpdate() {
    if (!channel) return;
    try {
      channel.postMessage({
        type: 'SESSION_UPDATE',
        sessionId: sessionId,
        history: history,
        hasOpened: hasOpened
      });
    } catch(e) {}
  }

  function tryHandshake(callback) {
    if (!channel) { callback(false); return; }
    var resolved = false;

    function onResponse(e) {
      var data = e.data || {};
      if (data.type === 'SESSION_RESPONSE' && !resolved) {
        resolved = true;
        channel.removeEventListener('message', onResponse);
        sessionId = data.sessionId;
        history = data.history || [];
        hasOpened = !!data.hasOpened;
        callback(true);
      }
    }

    channel.addEventListener('message', onResponse);

    try {
      channel.postMessage({ type: 'WHO_HAS_SESSION' });
    } catch(e) {
      channel.removeEventListener('message', onResponse);
      callback(false);
      return;
    }

    setTimeout(function() {
      if (!resolved) {
        resolved = true;
        channel.removeEventListener('message', onResponse);
        callback(false);
      }
    }, HANDSHAKE_TIMEOUT_MS);
  }

  function initSession(done) {
    setupChannel();

    if (isReload()) {
      // Refresh always resets, no matter what other tabs have
      initFresh();
      isReady = true;
      done();
      return;
    }

    // Not a reload: ask other tabs if they have a session to share
    tryHandshake(function(found) {
      if (!found) initFresh();
      isReady = true;
      done();
    });
  }

  // ---------- Click tracking ----------
  // Extracts the product handle from a Health Hub product URL.
  // e.g. https://www.healthhubstore.com/products/easy-iron-20mg?foo=bar -> easy-iron-20mg
  function extractProductHandle(href) {
    if (!href) return null;
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Fire a click record to n8n. Best-effort, silent, no credentials.
  // Uses a text/plain body to avoid a CORS preflight (simple request),
  // and explicitly omits credentials so the wildcard CORS origin works.
  function trackProductClick(handle, title) {
    if (!handle || !sessionId) return;
    try {
      var payload = JSON.stringify({
        session_id: sessionId,
        product_handle: handle,
        product_title: title || ''
      });
      // text/plain keeps it a "simple request" => no OPTIONS preflight.
      // n8n reads the raw body and parses JSON regardless of content-type.
      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: 'text/plain;charset=UTF-8' });
        navigator.sendBeacon(CLICK_WEBHOOK_URL, blob);
      } else {
        fetch(CLICK_WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: payload,
          keepalive: true,
          mode: 'cors',
          credentials: 'omit'
        }).catch(function(){});
      }
    } catch(e) {
      // Never let tracking break the user's click
    }
  }

  // ---------- UI ----------
  function init() {
    widget   = document.getElementById('hh-chat-widget');
    toggle   = document.getElementById('hh-chat-toggle');
    closeBtn = document.getElementById('hh-chat-close');
    messages = document.getElementById('hh-messages');
    input    = document.getElementById('hh-input');
    sendBtn  = document.getElementById('hh-send-btn');

    // Guard: if the widget markup is not present on this page, do nothing.
    if (!widget || !toggle || !messages || !input || !sendBtn) return;

    dot      = toggle.querySelector('.hh-dot');

    bubbleEl = document.getElementById('hh-chat-bubble');
    if (bubbleEl) {
      bubbleEl.addEventListener('click', function() { openChat(); });
    }

    var bubbleClose = document.getElementById('hh-bubble-close');
    if (bubbleClose) {
      bubbleClose.addEventListener('click', function(e) {
        e.stopPropagation();
        hideBubble();
      });
    }

    toggle.addEventListener('click', function() { isOpen ? closeChat() : openChat(); });
    closeBtn.addEventListener('click', function(e) { e.stopPropagation(); closeChat(); });

    // Delegated click tracking: one listener catches clicks on any product link
    // rendered inside the messages area, now or in the future.
    messages.addEventListener('click', function(e) {
      var link = e.target.closest ? e.target.closest('a') : null;
      if (!link) return;
      var href = link.getAttribute('href');
      var handle = extractProductHandle(href);
      if (handle) {
        trackProductClick(handle, (link.textContent || '').trim());
      }
    });

    input.addEventListener('input', function() {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 100) + 'px';
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); }
    });

    sendBtn.addEventListener('click', handleSend);

    initSession(function() { /* session ready */ });
  }

  function rerenderMessages() {
    if (!messages) return;
    messages.innerHTML = '';
    history.forEach(function(msg) {
      addMessage(msg.role === 'user' ? 'user' : 'agent', msg.content);
    });
  }

  function hideBubble() {
    if (bubbleEl) { bubbleEl.style.display = 'none'; bubbleEl.style.visibility = 'hidden'; }
  }

  function whenReady(fn) {
    if (isReady) { fn(); return; }
    var interval = setInterval(function() {
      if (isReady) { clearInterval(interval); fn(); }
    }, 50);
  }

  function openChat() {
    isOpen = true;
    widget.classList.add('open');
    if (dot) dot.style.display = 'none';
    hideBubble();

    whenReady(function() {
      if (!hasOpened) {
        hasOpened = true;
        var welcomeMsg = "Hi there! 👋 I am Anneliese, The Health Hub's virtual assistant. What can I help you with today? Whether it is sleep, energy, joints, digestion or anything else, just let me know.\n\nYour reference number for this chat is **" + sessionId + "**. Keep it handy for any follow-up.";
        addMessage('agent', welcomeMsg);
        history.unshift({ role: 'assistant', content: welcomeMsg });
        broadcastUpdate();
      } else if (messages.children.length === 0) {
        rerenderMessages();
      }
    });

    setTimeout(function(){ input.focus(); }, 300);
  }

  function closeChat() {
    isOpen = false;
    widget.classList.remove('open');
  }

  function handleSend() {
    var text = input.value.trim();
    if (!text || isLoading || !isReady) return;
    input.value = ''; input.style.height = 'auto';
    addMessage('user', text);
    sendMessage(text);
  }

  function addMessage(role, content) {
    var wrapper = document.createElement('div');
    wrapper.className = 'hh-message ' + role;
    var bubble = document.createElement('div');
    bubble.className = 'hh-bubble';
    bubble.innerHTML = renderMarkdown(content);
    wrapper.appendChild(bubble);
    messages.appendChild(wrapper);
    scrollToBottom();
  }

  function getLoadingText(seconds) {
    if (seconds < 8)  return 'Thinking...';
    if (seconds < 15) return 'Searching for the best options...';
    return 'Almost there, putting it all together...';
  }

  function showTyping() {
    var w = document.createElement('div');
    w.className = 'hh-message agent';
    w.id = 'hh-typing';
    w.innerHTML = [
      '<div class="hh-bubble hh-typing-bubble">',
      '  <div class="hh-typing-dots">',
      '    <span style="animation-delay:0s"></span>',
      '    <span style="animation-delay:0.15s"></span>',
      '    <span style="animation-delay:0.3s"></span>',
      '  </div>',
      '  <span class="hh-typing-text" id="hh-typing-text">Thinking...</span>',
      '</div>'
    ].join('');
    messages.appendChild(w);
    scrollToBottom();

    elapsedSeconds = 0;
    elapsedInterval = setInterval(function() {
      elapsedSeconds++;
      var el = document.getElementById('hh-typing-text');
      if (el) el.textContent = getLoadingText(elapsedSeconds);
    }, 1000);
  }

  function hideTyping() {
    var t = document.getElementById('hh-typing');
    if (t) t.remove();
    if (elapsedInterval) { clearInterval(elapsedInterval); elapsedInterval = null; }
    elapsedSeconds = 0;
  }

  function setInputDisabled(disabled) {
    input.disabled = disabled;
    sendBtn.disabled = disabled;
    input.style.opacity = disabled ? '0.5' : '1';
    sendBtn.style.opacity = disabled ? '0.4' : '1';
  }

  function scrollToBottom() { messages.scrollTop = messages.scrollHeight; }

  function renderMarkdown(text) {
    if (!text) return '';
    text = text.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" loading="lazy">');
    text = text.replace(/\*\*\[([^\]]+)\]\(([^)]+)\)\*\*/g, '<strong><a href="$2" target="_blank" rel="noopener">$1</a></strong>');
    text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/\n/g, '<br>');
    return text;
  }

  function sendMessage(userText) {
    isLoading = true;
    setInputDisabled(true);
    showTyping();

    var isFirstMessage = history.length === 0 || (history.length === 1 && history[0].role === 'assistant');
    history.push({ role: 'user', content: userText });
    broadcastUpdate();

    var controller = new AbortController();
    var timeoutId = setTimeout(function() { controller.abort(); }, TIMEOUT_MS);

    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
      body: JSON.stringify({
        sessionId: sessionId,
        message: userText,
        history: history,
        isFirstMessage: isFirstMessage
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function(data) {
      var d = Array.isArray(data) ? data[0] : data;
      var reply = d.reply || d.output || d.text || d.message || '';
      hideTyping();
      if (reply) {
        addMessage('agent', reply);
        history.push({ role: 'assistant', content: reply });
        broadcastUpdate();
      }
    })
    .catch(function(err) {
      hideTyping();
      var msg = err.name === 'AbortError'
        ? 'This is taking longer than usual. Please try again or call us in Ballincollig, Cork.'
        : 'Sorry, something went wrong. Please try again or call us in Ballincollig, Cork.';
      addMessage('agent', msg);
      console.error('[HH Chat]', err);
    })
    .finally(function() {
      clearTimeout(timeoutId);
      isLoading = false;
      setInputDisabled(false);
      input.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();